import axios from 'axios';

const isDev = process.env.NODE_ENV !== 'production';
const isBuildProd = process.env.BUILD_ENV === 'prod';

const instanse = axios.create({
    baseURL: isBuildProd ? 'https://api.tripshock.com/v1' : 'https://api.tripshock.com/dev_v1/',
    timeout: 30000,
});

export const contentInstanse = axios.create({
    baseURL: isBuildProd
        ? 'https://api.tripshock.com/content/'
        : 'https://api.tripshock.com/content-staging/',
    timeout: 30000,
});

const errorHandler = (error) => {
    if (error.request instanceof Object && error.request.method && error.request.path) {
        console.log(`Failed ${error.request.method} ${error.request.path}`);
    }
    return Promise.reject(error);
};

if (isDev) {
    instanse.interceptors.request.use((request) => {
        console.info('[Axios Request]', request.baseURL, request.url, request.params);
        return request;
    });

    contentInstanse.interceptors.request.use((request) => {
        console.info('[Axios Content Request]', request.baseURL, request.url, request.params);
        return request;
    });
}

instanse.interceptors.response.use((response) => response, errorHandler);
contentInstanse.interceptors.response.use((response) => response, errorHandler);

export default instanse;
